import { render, staticRenderFns } from "./project-statuses.vue?vue&type=template&id=4baf530f&scoped=true&"
import script from "./project-statuses.vue?vue&type=script&lang=js&"
export * from "./project-statuses.vue?vue&type=script&lang=js&"
import style0 from "./project-statuses.vue?vue&type=style&index=0&id=4baf530f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf530f",
  null
  
)

export default component.exports